import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[mapOption]',
    standalone: false
})
export class MapOptionDirective {
    constructor(public viewContainerRef: ViewContainerRef) { }
}

